import i18n from '@/i18n/i18n'
import PurchaseOfferService from '@/services/retailer/PurchaseOfferService.js'
import { build_query, errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global

export const allowedFilters = [
  'purchaseRequest.farmer_name',
  'product_name',
  'purchaseRequest.created_between',
  'purchaseRequest.farmer_payment_type',
  'status'
]

export const namespaced = true

export const state = {
  purchaseOffers: null,
  purchaseOffer: {},
  purchasePriceOfferWaitingProducts: []
}

export const mutations = {
  SET_PURCHASE_OFFERS(state, purchaseOffers) {
    state.purchaseOffers = purchaseOffers.data
  },
  SET_PURCHASE_OFFER(state, purchaseOffer) {
    state.purchaseOffer = purchaseOffer
  },
  SET_PURCHASE_PRICE_OFFER_WAITING_PRODUCTS(state, purchasePriceOfferWaitingProducts) {
    state.purchasePriceOfferWaitingProducts = purchasePriceOfferWaitingProducts
  }
}

export const actions = {
  getPurchaseOffers({ commit, dispatch }, query) {
    let newQuery = build_query(query, allowedFilters)
    return new Promise((resolve, reject) => {
      PurchaseOfferService.getPurchaseOffers(newQuery)
        .then(response => {
          commit('SET_PURCHASE_OFFERS', response)
          resolve(response.data)
        })
        .catch(err => {
          const notifications = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notifications, {
            root: true
          })
          reject(err)
        })
    })
  },
  getPurchaseOffer({ commit }, id) {
    return new Promise(resolve => {
      PurchaseOfferService.getPurchaseOffer(id).then(response => {
        commit('SET_PURCHASE_OFFER', response.data)
        resolve(response.data)
      })
    })
  },
  createPurchaseOffer({ commit, dispatch, state }, purchaseOffer) {
    return new Promise((resolve, reject) => {
      PurchaseOfferService.createPurchaseOffer(state.purchaseOffer.id, purchaseOffer)
        .then(response => {
          let items = purchaseOffer.items
          let message = 'views.retailer.purchase_offers.offer_created_and_prices_updated'

          if (
            purchaseOffer.excluded_items_for_mobile_price_update?.length > 0 &&
            items.every(item => purchaseOffer.excluded_items_for_mobile_price_update.includes(item.id))
          ) {
            message = 'views.retailer.purchase_offers.offer_created'
          }

          const notification = {
            type: 'success',
            message: t(message, { product: items.map(item => item.product_name).join(', ') })
          }

          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  ignorePurchaseOffer({ dispatch }, purchaseOfferId) {
    return new Promise((resolve, reject) => {
      PurchaseOfferService.ignorePurchaseOffer(purchaseOfferId)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('views.retailer.purchase_offers.offer_removed')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getPurchasePriceOfferWaitingProducts({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      PurchaseOfferService.getPurchasePriceOfferWaitingProducts()
        .then(response => {
          commit('SET_PURCHASE_PRICE_OFFER_WAITING_PRODUCTS', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
